/**
 * Cierra un modal solo si pointerdown y pointerup ocurren sobre el overlay.
 * Evita cerrar al seleccionar texto en un input y soltar el click fuera del panel.
 */
export function useModalOverlayDismiss(onClose) {
  let pointerDownOnOverlay = false

  const onOverlayPointerDown = (event) => {
    pointerDownOnOverlay = event.target === event.currentTarget
  }

  const onOverlayPointerUp = (event) => {
    if (pointerDownOnOverlay && event.target === event.currentTarget) {
      onClose()
    }
    pointerDownOnOverlay = false
  }

  return { onOverlayPointerDown, onOverlayPointerUp }
}
